import { gql } from '@apollo/client'

export const AUDIT_ANSWER_FRAGMENT = gql`
  fragment AuditAnswer on AuditAnswer {
    id
    question
    answeredYes
    questionId
    image {
      id
      url
      saved
    }
  }
`
